import { ReactElement } from 'react';
import classNames from 'classnames';
import { Icon } from '@nx-frontend/shared/ui/icon';
import { getFirstLetters } from '@nx-frontend/shared/utils';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export interface AvatarProps {
  name: string;
  avatarUrl?: string;
  bgClass?: string;
  size?: AvatarSize;
  icon?: ReactElement;
}

export const Avatar: React.FC<AvatarProps> = ({ name, avatarUrl, bgClass, size = 'sm', icon }) => {
  const initials = getFirstLetters(name);
  const avatarStyle = {
    backgroundImage: `url(${avatarUrl})`,
  };

  const avatarBg = bgClass ?? 'bg-teal-500';
  const sizeMap = {
    xs: 'h-4 w-4 min-w-4 text-[8px]',
    sm: 'h-6 w-6 min-w-6 text-[10px]',
    md: 'h-8 w-8 min-w-8',
    lg: 'h-10 w-10 min-w-10',
    xl: 'h-12 w-12 min-w-12',
  };
  const avatarSize = sizeMap[size];
  return (
    <div
      className={classNames('flex items-center justify-center font-medium rounded-full p-0.5 text-white', avatarSize, {
        [avatarBg]: !avatarUrl,
        'bg-cover': avatarUrl,
      })}
      style={avatarUrl ? avatarStyle : undefined}
    >
      {!avatarUrl && !icon && initials}
      {!avatarUrl && icon && <Icon icon={icon} className="w-4 h-4" />}
    </div>
  );
};
